export const GET_INVENTORY_STOCK_PRODUCTS: { [x: string]: any } = {
  LOADING: "INVENTORY_STOCK_PRODUCTS_GET_LOADING",
  SUCCESS: "INVENTORY_STOCK_PRODUCTS_GET_SUCCESS",
  ERROR: "INVENTORY_STOCK_PRODUCTS_GET_ERROR",
};
